/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import { connect } from 'react-redux';
import PeoplePage from '../../components/people/people.container';

const PeoplePageContainer = connect()(PeoplePage);

export default PeoplePageContainer;
